export enum DatePickerNames {
  SECRETS = 'secrets',
  ACCESS_INSIGHTS = 'access-insights',
  ASSETS_ACTIVITY = 'assets-activity',
  ASSETS_PIPELINE = 'assets-pipeline',
  ASSETS_PULL_REQUESTS = 'assets-pull-requests',
  IDENTITIES_ACTIVITY = 'identities-activity',
  IDENTITIES_AUDIT_TRAIL = 'identities-audit-trail',
  IDENTITIES_PIPELINE_ACTIVITY = 'identities-pipeline-activity',
  PRODUCTIVITY_INSIGHTS = 'productivity-insights',
  ORGANIZATIONAL_TEAMS_PRODUCTIVITY = 'organizational-teams-productivity',
  IAC_VULNERABILITY_INSIGHTS = 'iac-vulnerability-insights',
  SAST_VULNERABILITY_INSIGHTS = 'sast-vulnerability-insights',
  DAST_VULNERABILITY_INSIGHTS = 'dast-vulnerability-insights',
  SECRET_VULNERABILITY_INSIGHTS = 'secret-vulnerability-insights',
  CSPM_VULNERABILITY_INSIGHTS = 'cspm-vulnerability-insights',
  CONTAINER_VULNERABILITY_INSIGHTS = 'container-vulnerability-insights',
  REGISTRY_VULNERABILITY_INSIGHTS = 'registry-vulnerability-insights',
  OSS_VULNERABILITY_INSIGHTS = 'oss-vulnerability-insights',
  ALL_VULNERABILITY_INSIGHTS = 'all-vulnerability-insights',
  VULNERABILITY_OVERVIEW = 'vulnerability-overview',
  CI_CD_INSIGHTS = 'ci-cd-insights',
}
